import { useSuspenseQuery } from '@tanstack/react-query';
import { networksQueryOptions } from '#api/networks.queries.ts';
import { useBrowserStorage } from '#hooks/useBrowserStorage.ts';
import { Protected } from './Protected.tsx';

/** Session storage key set when a user skips the get-started flow; lets them into the admin panel with no network. */
export const SKIPPED_GET_STARTED_KEY = 'skippedGetStarted';

type Props = {
  children: React.ReactNode;
};

/**
 * A component that redirects to the GettingStarted page if there is no network created, unless the user skipped
 * the flow this session.
 */
export function GotStarted({ children }: Props) {
  const {
    data: { data: networks },
  } = useSuspenseQuery(networksQueryOptions);
  const [skippedGetStarted] = useBrowserStorage(SKIPPED_GET_STARTED_KEY);

  const hasNetworks = Boolean(networks.length);

  return (
    <Protected isPermitted={() => hasNetworks || skippedGetStarted != null} redirectTo="/get-started">
      {children}
    </Protected>
  );
}
